import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";
import Tooltip from "material-ui/Tooltip";

const styles = () => ({
  arrowtop: {
    position: "absolute",
    fontSize: 6,
    bottom: 0,
    left: "calc(50% - 1.5em)",
    marginBottom: "-0.95em",
    width: "3em",
    height: "1em",

    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "1em 1em 0 1em",
      borderColor: `#181819 transparent transparent transparent`,
    },
  },

  arrowbottom: {
    position: "absolute",
    fontSize: 6,
    top: 0,
    left: "calc(50% - 1.5em)",
    marginTop: "-0.95em",
    width: "3em",
    height: "1em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "0em 1em 1em 1em",
      borderColor: `transparent transparent #181819 transparent`,
    },
  },

  tooltipRoot: {
    display: "flex",
  },

  tooltip: {
    fontWeight: 200,
    fontSize: 13,
    backgroundColor: "#181819",
    padding: "12px 15px",
    opacity: 1,
  },

  tooltipMaxWidth300: {
    maxWidth: 300,
  },

  tooltipMaxWidth200: {
    maxWidth: 200,
  },

  tooltipEmpty: {
    padding: 0,
    opacity: 0,
  },
});

const ArrowToolTip = ({
  classes,
  text,
  children,
  style = {},
  tooltipMaxWidth = "300",
  placement = "top",
  arrowClass,
}) => {
  return (
    <Tooltip
      placement={placement}
      title={
        <React.Fragment>
          {text}
          <span
            className={arrowClass ? arrowClass : classes["arrow" + placement]}
          />
        </React.Fragment>
      }
      classes={{
        root: classes.tooltipRoot,
        tooltip: !text ? classes.tooltipEmpty : classNames(classes.tooltip, classes["tooltipMaxWidth" + tooltipMaxWidth]),
      }}
      style={style}
    >
      {children}
    </Tooltip>
  );
};

ArrowToolTip.propTypes = {
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  children: PropTypes.object,
  tooltipMaxWidth: PropTypes.string,
  placement: PropTypes.string,
  arrowClass: PropTypes.string,
};

export default withStyles(styles)(ArrowToolTip);



// WEBPACK FOOTER //
// ./src/components/common/ArrowToolTip.jsx